import { FlashSaleBundleTile } from "@faire/deprecated-retailer-visitor-shared/components/FlashSaleBundleTile/FlashSaleBundleTile";
import {
  IProps,
  CarouselBase,
  BaseCarouselProps,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { isNotUndefined } from "@faire/typescript";
import { IFlashSaleTile } from "@faire/web-api--source/indigofair/data/IFlashSaleTile";
import * as React from "react";

export const FlashSaleCarousel: React.FC<BaseCarouselProps> = (props) => {
  const CarouselBaseComponent = CarouselBase as React.ComponentType<
    IProps<IFlashSaleTile>
  >;

  const { onItemClick, requestId, layoutElement, onVisible } =
    React.useContext(Context);

  const getItems = () => {
    return layoutElement.layout_element_data
      .map((elementData) => elementData.flash_sale_tile)
      .filter(isNotUndefined);
  };

  const renderFlashSaleTileCarousel = (flashSaleTile: IFlashSaleTile) => {
    return (
      <FlashSaleBundleTile
        key={flashSaleTile.token}
        item={flashSaleTile}
        onClick={(flashSaleToken) => {
          onItemClick?.(
            layoutElement.on_click_event_name ?? "",
            requestId,
            flashSaleToken
          );
        }}
      />
    );
  };

  const onItemsVisible = (items: IFlashSaleTile[]) => {
    const itemTokens = items.map((item) => item.token).filter(isNotUndefined);
    if (layoutElement.on_click_event_name) {
      onVisible?.(
        layoutElement.on_click_event_name,
        requestId,
        itemTokens.join(" ")
      );
    }
  };

  return (
    <CarouselBaseComponent
      noWrap
      renderItem={renderFlashSaleTileCarousel}
      items={getItems()}
      itemsPerSlide={{
        mobileAndAbove: 1,
        tabletAndAbove: 2,
        desktopAndAbove: 3,
      }}
      peekNextPercent={{
        mobileAndAbove: 15,
        tabletAndAbove: 0,
      }}
      onItemsVisible={onItemsVisible}
      {...props}
    />
  );
};
